import { useEffect } from "react";
import { useAuth } from "@/context/AuthContext";
import { currentPermission, subscribePush } from "@/lib/push";

const KEY = "tl_push_auto_asked";

// Alerts are on by default. Browsers only allow the permission prompt inside a user gesture,
// so we ask on the first tap/click after sign-in — silently, once. Users can turn push off in Settings.
export const useAutoPush = () => {
  const { user } = useAuth();
  useEffect(() => {
    if (!user || user.notification_prefs?.push === false || sessionStorage.getItem(KEY)) return;
    let armed = true;
    const ask = async () => {
      if (!armed) return;
      armed = false;
      document.removeEventListener("pointerdown", ask, true);
      sessionStorage.setItem(KEY, "1");
      try {
        if ((await currentPermission()) !== "default") return;
        await subscribePush();
      } catch { /* best-effort */ }
    };
    currentPermission().then((p) => { if (p === "default") document.addEventListener("pointerdown", ask, true); else sessionStorage.setItem(KEY, "1"); });
    return () => { armed = false; document.removeEventListener("pointerdown", ask, true); };
  }, [user]);
};
